import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Form, Select, Button, message } from 'antd';
import { NumberInput } from 'shared_components/pattern_input';
import { searchInventoryAPI } from 'services/blood_inventory/blood_inventory';
import fetchBloodStorage from 'services/blood_inventory/blood_storage';
import { fetchBloodTypes } from 'services/blood_bank/blood_types';
import './index.css';

const { Option } = Select;

function SearchForm({ onFinish }) {
	const formRef = useRef();
	const [loading, setLoading] = useState(false);
	const [bloodStorage, setBloodStorage] = useState([]);
	const [bloodTypes, setBloodTypes] = useState([]);

	console.log('xxformRefxx', formRef);

	useEffect(() => {
		async function fetchData() {
			const bloodStorage = await fetchBloodStorage();
			const bloodTypes = await fetchBloodTypes();

			setBloodStorage(bloodStorage);
			setBloodTypes(bloodTypes);
		}
		setLoading(true);
		fetchData();
		setLoading(false);
	}, []);

	const StorageOptions = bloodStorage
		.sort((a, b) => (a.storage_name > b.storage_name ? 1 : -1))
		.map(item => (
			<Option key={item.blood_storage_id} value={item.storage_name}>
				{item.storage_name}
			</Option>
		));

	const BloodTypeOptions = bloodTypes
		//(a, b) => a.key > b.key ? 1 : -1
		//(a, b) => a.blood_type - b.blood_type
		.sort((a, b) => (a.blood_type > b.blood_type ? 1 : -1))
		.map(item => (
			<Option key={item.blood_type_id} value={item.blood_type}>
				{item.blood_type}
			</Option>
		));

	async function handleSubmit(formValues) {
		const searchInventoryManual = await searchInventoryAPI(formValues);
		onFinish(searchInventoryManual);

		if (searchInventoryManual.length <= 0) message.info('No results found');
	}

	function clearSearch() {
		// @ts-ignore
		const { setFieldsValue } = formRef.current;
		setFieldsValue({ bag_id: '', blood_type: '', storage: '' });

		console.log('xxsfvxx', formRef.current);
	}

	return (
		<Form
			className="blood-inventory-search-form"
			onFinish={handleSubmit}
			ref={formRef}
			layout="vertical"
		>
			<div className="container">
				<Col className="bag-id">
					<Form.Item
						label="BAG ID"
						name="bag_id"
						// style={{ marginRight: 10 }}
					>
						<NumberInput style={{ width: '100%' }} maxLength={10} placeholder="BAG ID" />
					</Form.Item>
				</Col>
				<Col className="blood-type">
					<Form.Item name="blood_type" label="BLOOD TYPE" className="no-padding">
						<Select style={{ width: '100%' }} placeholder="Select Blood Type">
							{BloodTypeOptions}
						</Select>
					</Form.Item>
				</Col>
				<Col className="blood-storage">
					<Form.Item name="storage" label="STORAGE" className="no-padding">
						<Select style={{ width: '100%' }} placeholder="Select Storage">
							{StorageOptions}
						</Select>
					</Form.Item>
				</Col>
				<Col>
					<Form.Item shouldUpdate>
						{({ getFieldsValue }) => {
							const { bag_id, blood_type, storage } = getFieldsValue();
							const disabled = !(bag_id || blood_type || storage);

							return (
								<div className="buttons">
									<Button
										className="form-button"
										shape="round"
										style={{ width: 120 }}
										onClick={clearSearch}
									>
										CLEAR
									</Button>
									<Button
										loading={loading}
										className="form-button"
										shape="round"
										type="primary"
										htmlType="submit"
										style={{ width: 120 }}
										disabled={disabled}
										//onClick={handleSubmit}
									>
										SEARCH
									</Button>
								</div>
							);
						}}
					</Form.Item>
				</Col>
			</div>
		</Form>
	);
}

export default SearchForm;
